import CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import { action } from 'satcheljs';

/**
 * Shows the drag and drop meeting confirmation modal and sets it's calendarItem
 * @calendarItemUpdates The updated properties in the calendar item after drag and drop
 * @originalEvent The original event prior to drag and drop
 */
let showMeetingDndModal = action(
    'showMeetingDndModal',
    (calendarItemUpdates: CalendarEvent, originalEvent: CalendarEvent) => ({
        calendarItemUpdates: calendarItemUpdates,
        originalEvent: originalEvent,
    })
);

export default showMeetingDndModal;
